import _ from 'lodash';
import { TextBrandProps, getTextStylesFromBrandStyle } from 'modules/BrandDefinition';
import { applyOverridenPadding } from 'modules/BrandDefinition/utils';
import * as Models from 'models';
import { toJS } from 'utils/immutable';
import { applyBrandStyleOnRelation } from './applyBrandStyleOnRelation';

const getStylesToMergeFromBrandStyles = (
  styles: Models.TextRelationStyles,
  sourceTextBrandStyles: Models.TextBrandStyles,
  targetTextBrandStyles: Models.TextBrandStyles,
): string[] => {
  const {
    backgroundColor,
    isAutoFitContent,
  } = styles;

  let stylesToApply: string[] = [];

  if (backgroundColor && backgroundColor === sourceTextBrandStyles.fontColor) {
    stylesToApply.push(Models.TextBrandStyleField.BACKGROUND_COLOR);
  }

  // applied to both old RL with no autofit and new when autofit is off
  if (!isAutoFitContent) {
    stylesToApply.push(Models.TextBrandStyleField.IS_AUTOFIT_CONTENT);
  }

  Object.keys(targetTextBrandStyles).forEach((styleName) => {
    const targetValue: string = targetTextBrandStyles[styleName];

    if (!targetValue || targetValue.length === 0) {
      stylesToApply = stylesToApply.filter(style => style !== styleName);
    }
  });

  return stylesToApply;
};

export function mergeBrandStylesOnRelation(
  styles: Models.TextRelationStyles,
  layoutBrandProps: TextBrandProps,
  projectBrandProps: TextBrandProps,
): Models.TextRelationStyles {
  const updatedStyles = _.cloneDeep(styles);

  const layoutBrandStyleProps = getTextStylesFromBrandStyle(
    layoutBrandProps.brandStyle,
    layoutBrandProps.colors,
    layoutBrandProps.fonts,
  );
  const projectBrandStyleProps = getTextStylesFromBrandStyle(
    projectBrandProps.brandStyle,
    projectBrandProps.colors,
    projectBrandProps.fonts,
  );

  const stylesToMergeFromBrandStyles = getStylesToMergeFromBrandStyles(
    styles,
    layoutBrandStyleProps,
    projectBrandStyleProps,
  );
  const adoptedStylesFromBrandStyles = applyBrandStyleOnRelation(styles, projectBrandProps);

  if (stylesToMergeFromBrandStyles.length > 0) {
    stylesToMergeFromBrandStyles.forEach((styleName) => {
      if (styleName === Models.TextBrandStyleField.IS_AUTOFIT_CONTENT) {
        // is autofit content always false if exists as override
        updatedStyles[styleName] = false;
      } else {
        updatedStyles[styleName] = adoptedStylesFromBrandStyles[styleName];
      }
    });
  }

  applyOverridenPadding(
    toJS(projectBrandStyleProps.padding),
    toJS(layoutBrandStyleProps.padding),
    updatedStyles,
  );

  return updatedStyles;
}
